import React from 'react'

import { MdmObjectDto, useGetObjectQuery, useUpdateObjectMutation } from 'gql/generated/types'
import { ProgressSpinner } from 'primereact/progressspinner'
import { useParams } from 'react-router-dom'
import { T } from 'services/lang/LanguageService'
import ObjectForm from '../components/ObjectForm'
import { errorToaster, successToaster } from '../utils/utils'
import ErrorPage from './ErrorPage'

const EditObjectForm = () => {
  const { objectId } = useParams();
  const { data, error, loading } = useGetObjectQuery({ variables: { id: objectId! } });
  const [updateObjectMutation, {loading: updateLoading}] = useUpdateObjectMutation({
    onCompleted: () => successToaster(T("alert.object-updated-successfully")),
    onError: errorToaster,
  });
  
  if (error) {
    return <ErrorPage msg={error.message} />;
  }

  if (loading) return <ProgressSpinner className='mt-3 w-full' />

  const handleUpdate = (object: MdmObjectDto) => {
    const { deviceRelations, boundDatasets, address, info, ...restObject } = object;
    if (!address) {
      updateObjectMutation({ variables: { object: restObject } });
    } else {
      const { fullAddress, ...restAddress } = address!;
      updateObjectMutation({ variables: { object: { ...restObject, address: restAddress } } });
    }

  }

  return <ObjectForm object={data?.mdmObjectById as MdmObjectDto} onSubmit={handleUpdate} loading={updateLoading} />
}

export default EditObjectForm